<template>
  <div class="role-page full-height">
    <table-con>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/orders' }"
            >首页</el-breadcrumb-item
          >
          <el-breadcrumb-item>消息管理</el-breadcrumb-item>
          <el-breadcrumb-item>消息群发</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="search">
        <el-row class="search-row">
          <el-col :span="6" class="display-row">
            <div class="query-title">用户姓名:</div>
            <div class="flex1">
              <el-input
                placeholder="请输入内容"
                clearable
                v-model="queryInfo.realName"
                size="small"
                @keyup.enter.native="searchCustomer"
              >
              </el-input>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="query-title">用户ID:</div>
            <div class="flex1">
              <el-input
                placeholder="请输入内容"
                clearable
                v-model="queryInfo.userName"
                size="small"
                @keyup.enter.native="searchCustomer"
              >
              </el-input>
            </div>
          </el-col>
          <el-col :span="12" class="display-row">
            <div style="text-align: right; width: 100%; padding-right: 10px">
              <el-button
                class="search-btn btn-green"
                :disabled="message.userNameList.length <= 0"
                @click="massMessage"
                >群发</el-button
              >
              <el-button class="search-btn btn-gray" @click="clearConditions"
                >重置</el-button
              >
              <el-button class="search-btn btn-blue" @click="searchCustomer"
                >搜索</el-button
              >
            </div>
          </el-col>
        </el-row>
      </div>
      <div slot="table" class="full-height display-col">
        <el-table
          :data="customerList"
          :header-cell-style="tableStyle.headerStyle"
          v-loading="isLoading"
          :cell-style="tableStyle.cellStyle"
          border
          ref="multipleTable"
          @select="tableSelect"
          @select-all="tableSelectAll"
          height="550"
        >
          <el-table-column align="center" type="selection"> </el-table-column>
          <el-table-column
            align="center"
            type="index"
            label="序号"
            width="40"
          ></el-table-column>
          <el-table-column align="center" label="操作">
            <template slot-scope="scope">
              <el-button
                class="list-btn-four btn-blue"
                @click="reply(scope.row)"
                >提醒</el-button
              ><br />
            </template>
          </el-table-column>
          <el-table-column prop="realName" label="用户姓名" align="center"></el-table-column>
          <el-table-column prop="userName" label="用户ID" align="center"></el-table-column>
          <el-table-column
            prop="createTime"
            label="创建时间"
            align="center"
            sortable
            width="160"
            :index="indexMethod"
            :formatter="dateFormatYMDHMS"
          ></el-table-column>
          <el-table-column
            prop="staffUserRealName"
            label="负责人"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="userFlag"
            label="用户状态"
            align="center"
            :index="indexMethod"
            sortable
            :formatter="statusFormatter"
          ></el-table-column>
          <el-table-column
            prop="latestSigninTime"
            label="最新登录时间"
            align="center"
            sortable
            width="160"
            :index="indexMethod"
          >
            <template v-slot="scope">
              {{ scope.row.latestSigninTime | dateFormatToSecond }}
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.pageNum"
          :page-sizes="[20, 50, 100, 200, 300]"
          :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </table-con>

    <MessageTip
      :visiable.sync="messageTipVisiable"
      :userName="message.userName"
      :userNameList="message.userNameList"
      :type="message.type"
      messageType="普通消息"
      httpUrl="customer/message"
      massMessageHttpUrl="customer/massMessage"
      @confirm="onConfirmMsg"
    ></MessageTip>
    <!-- <MessageTip
      :visiable.sync="messageTipVisiable"
      :info="message"
      @confirm="onConfirmMsg"
    ></MessageTip> -->
  </div>
</template>

<script>
import tableCon from "../../views/tableContainer";
import MessageTip from "@/components/MessageTip/index2.vue";
import { MessageSend } from "@/class";

export default {
  components: { tableCon, MessageTip },
  data() {
    return {
      fileList: [],
      isLoading: false,
      rules: {
        remindingTitle: [
          { required: true, message: "请输入标题", trigger: "blur" },
        ],
        remindingContent: [
          { required: true, message: "请输入消息提醒内容", trigger: "blur" },
        ],
      },
      queryInfo: {
        userName: "",
        realName: "",
        pageSize: 20,
        pageNum: 1,
      },
      total: 0,
      customerList: [],
      message: {
        type: 0,
        userName: "",
        userNameList: [],
      },
      messageTipVisiable: false, // 消息提醒弹框
    };
  },
  methods: {
    searchCustomer() {
      this.queryInfo.pageNum = 1;
      this.queryInfo.pageSize = 20;
      this.getCustomerList();
    },
    tableSelect(selection) {
      this.tableSelectAll(selection);
    },
    tableSelectAll(selection) {
      this.message.userNameList = selection.map((item) => {
        return item.userName;
      });
    },
    dateFormatYMDHMS(row, column) {
      var dateStr = row[column.property];
      if (dateStr != null) {
        var date = new Date(parseInt(dateStr) * 1000);
        return (
          date.getFullYear() +
          "-" +
          (date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1) +
          "-" +
          date.getDate() +
          " " +
          date.getHours() +
          ":" +
          date.getMinutes() +
          ":" +
          date.getSeconds()
        );
      }
      return "";
    },
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1;
    },
    statusFormatter(row) {
      if (row.userFlag == 0) {
        return "启用";
      } else {
        return "禁用";
      }
    },
    hotboomFormatter(row) {
      if (row.hotboomFlag == 0) {
        return "关闭";
      } else {
        return "开启";
      }
    },
    handleSizeChange(pageSize) {
      this.queryInfo.pageSize = pageSize;
      this.getCustomerList();
    },
    handleCurrentChange(pageNumber) {
      this.queryInfo.pageNum = pageNumber;
      this.getCustomerList();
    },
    clearConditions() {
      this.queryInfo = {
        userName: "",
        userId: "",
      };
      this.message.userName = "";
      this.message.userNameList = [];
      this.$refs.multipleTable.clearSelection();
    },
    async getCustomerList() {
      this.isLoading = true;
      const { data: res } = await this.$http.get("customer/customerList", {
        params: this.queryInfo,
      });
      this.customerList = res.data.list;
      this.total = res.data.total;
      this.isLoading = false;
    },
    //消息提醒(单个)
    reply(row) {
      //提醒
      // const list = [
      //   {
      //     key: "userName",
      //     type: "elInput", //view
      //     label: "用户ID：",
      //     vModel: row.userName,
      //     vBind: { disabled: true },
      //   },
      // ];
      // MessageSend.replyInfo.id = "";
      // MessageSend.replyInfo.me = "";
      // MessageSend.httpUrl = "/customer/message";
      // MessageSend.message.onAdd("提醒", list);
      this.message.type = 0;
      this.message.userName = row.userName;
      this.messageTipVisiable = true
    },
    //消息提醒(群发)
    massMessage() {
      this.message.type = 1;
      this.messageTipVisiable = true;
    },
    onConfirmMsg() {
      this.messageTipVisiable = false;
    },
  },
  created() {
    this.getCustomerList();
  },
};
</script>

<style lang="less" scoped>
.role-page > .search-container {
  height: 60px !important;
}
.el-table .el-button--small {
  padding: 4px 10px;
}
</style>
